<template>
  <!-- 이미지+텍스트 형 -->
  <div>
    <v-card class="marketing-push-edit-area">
      <template-media></template-media>
      <template-text></template-text>
      <template-button></template-button>
    </v-card>
  </div>
</template>

<script>
import templateText from './templateFragments/templateText'
import templateButton from './templateFragments/templateButton'
import templateMedia from './templateFragments/templateMedia'
export default {
  data () {
    return {
      id: ''
    }
  },
  components: {
    templateText,
    templateButton,
    templateMedia
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.marketing-push-edit-area {
  padding: 0px 0px 1px 0px;
  border: 0px;
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/push/components/pushTemplateMediaText.vue